import React, { useState } from "react";
import * as contentful from "contentful";
import "./section-info-sale-inactive.scss";
import Breadcrumb from "../../../shared/components/atoms/breadcrumb/breadcrumb";
import iconArrow from "../../../shared/assets/images/icons/icon-arrow-left.svg";
import iconAlert from "../../../shared/assets/images/icons/pic-megaphone.svg";
import Redirect from "../../../shared/components/atoms/redirect/redirect";
import { useEffect } from "react";

const SectionInfoSaleInactive = (props) => {
  const { sale } = props;
  const { textoCuandoNoEstaDisponible, textoRedirectParaEstadoInactivo } = sale;

  const BienRandom = () => {
    const [bienRandom, setBienRandom] = useState([]);
    

    useEffect(() => {
      const getBien = async () => {
        const client = contentful.createClient({
          space: process.env.CONTENTFUL_SPACE_ID,
          accessToken: process.env.CONTENTFUL_ACCESS_TOKEN,
          environment: process.env.ENVIRONMENT === "production" ? "master" : "develop",
        });

        const result = await client.getEntries().then((response) => {
          const bienesDisponibles = response.items.filter(
            (item) =>
              item.sys.contentType.sys.id == "bien" &&
              item.fields.disponible == true
          );
          const createRandom =
            bienesDisponibles[
              Math.floor(Math.random() * bienesDisponibles.length)
            ];
          return createRandom;
        });
        setBienRandom(result.fields);
      };

      getBien();
    }, []);

    console.log(bienRandom, "Soy random");
    return bienRandom ? (
      <div className="o-section-info-sale-inactive-random-sale">
        <div className="o-section-info-sale-inactive-random-sale-info">
          <span className="o-section-info-sale-inactive-random-sale-info-title">
            Bienes Inmuebles
          </span>
          <div>
            <h6 className="o-section-info-sale-inactive-random-sale-info-name">
              {bienRandom.nombre}
            </h6>
            <p className="o-section-info-sale-inactive-random-sale-info-description">
              {bienRandom.metaDescripcion}
            </p>
            <Redirect
              url={`bienes-en-venta/${bienRandom.slug}`}
              className="button orange"
            >
              <span>Me interesa</span>
            </Redirect>
          </div>
        </div>

        {bienRandom.bannerRandom ? (
          <div className="o-section-info-sale-inactive-random-sale-banner">
            <img src={bienRandom.bannerRandom.fields.file.url} />
          </div>
        ) : (
          <></>
        )}
        {bienRandom.bannerRandomMobile ? (
          <div className="o-section-info-sale-inactive-random-sale-banner-mobile">
            <img src={bienRandom.bannerRandomMobile.fields.file.url} />
          </div>
        ) : (
          <></>
        )}
      </div>
    ) : (
      <></>
    );
  };

  const backLink = () => (
    <Redirect url="bienes-en-venta" className="link back-button">
      <img src={iconArrow} alt="icon back"></img>
      <span>Volver</span>
    </Redirect>
  );

  return (
    <div className="o-section-info-sale-inactive">
      <div className="o-section-info-sale-inactive-breadcrumb">
        <Breadcrumb />
      </div>
      <div className="o-section-info-sale-inactive-back-desktop">
        {backLink()}
      </div>
      <div className="o-section-info-sale-inactive-info">
        <img
          className="o-section-info-sale-inactive-info-icon"
          src={iconAlert}
        />
        <h1 className="o-section-info-sale-inactive-info-text">
          {textoCuandoNoEstaDisponible}
        </h1>
        <Redirect url="bienes-en-venta" className="button back-button">
          <span>{textoRedirectParaEstadoInactivo}</span>
        </Redirect>
      </div>
      <BienRandom />
    </div>
  );
};

export default SectionInfoSaleInactive;
